var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg41",
    viewBox: "1925.358 6183.438 36.101 36.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs22"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 16.379,
    x2: 16.379,
    y1: 29.515,
    y2: 34.985,
    gradientTransform: "scale(.98166 1.01869)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop6",
    offset: 0,
    stopColor: "#a8a9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop8",
    offset: 1,
    stopColor: "#545554"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    fill: "#a8a9a8",
    d: "M3.907 33.37c-1.069 0-1.935-.617-1.935-1.377v-4.387H.758A.758.758 0 0 1 0 26.848V7.129a.758.758 0 0 1 .758-.758h1.214V1.377C1.972.617 2.838 0 3.907 0h28.287c1.069 0 1.935.617 1.935 1.377v4.994h1.213a.758.758 0 0 1 .759.758v19.719a.758.758 0 0 1-.759.758h-1.213v4.387c0 .761-.867 1.377-1.935 1.377z",
    className: "cls-1",
    "data-name": "Union 5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_1",
    width: 50.157,
    height: 51.371,
    x: 1918.33,
    y: 6177.438,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset11",
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur13",
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood15",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite17",
    in2: "blur",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite19",
    in: "SourceGraphic",
    in2: "result1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_Sensor",
    "data-name": "Color Sensor",
    transform: "translate(1346 5555.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    clipPath: "url(#clip-path)",
    "data-name": "Mask Group 5",
    transform: "translate(579.358 629.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    fill: "#a8a9a8",
    d: "M.758 0h34.584a.758.758 0 0 1 .758.758v19.719a.758.758 0 0 1-.758.758H.758A.758.758 0 0 1 0 20.477V.758A.758.758 0 0 1 .758 0Z",
    className: "cls-1",
    "data-name": "Path 28",
    transform: "translate(0 6.371)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    filter: "url(#Path_1)",
    transform: "translate(-1925.36 -6183.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    fill: "url(#linear-gradient)",
    d: "M1.935 0h28.287c1.069 0 1.935.617 1.935 1.377v30.616c0 .761-.866 1.377-1.935 1.377H1.935C.866 33.371 0 32.754 0 31.993V1.377C0 .617.866 0 1.935 0Z",
    "data-name": "Path 1",
    transform: "translate(1927.33 6183.44)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M0 0h.758v6.067H0z",
    "data-name": "Rectangle 2",
    transform: "translate(34.584 9.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    d: "M0 0h.758v6.067H0z",
    "data-name": "Rectangle 5",
    transform: "translate(.91 9.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    d: "M0 0h.758v6.067H0z",
    "data-name": "Rectangle 3",
    transform: "translate(34.584 18.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    d: "M0 0h.758v6.067H0z",
    "data-name": "Rectangle 4",
    transform: "translate(.91 18.05)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    fill: "#b72b1c",
    d: "M2.579 17.747a7 7 0 0 1 .16-1.494 9.556 9.556 0 1 1 13.634 0 6.978 6.978 0 1 1-13.794 1.494z",
    "data-name": "Union 1",
    transform: "translate(8.494 4.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    d: "M2.67 16.308a5.374 5.374 0 0 1 .372-1.971 8.039 8.039 0 1 1 10.022-.022A5.388 5.388 0 1 1 2.67 16.308Z",
    "data-name": "Union 2",
    transform: "translate(10.011 5.534)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(14.41 10.163)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    cx: 3.64,
    cy: 3.64,
    r: 3.64,
    fill: "#f2f2f2",
    className: "cls-5",
    "data-name": "Ellipse 5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    cx: 1.972,
    cy: 1.972,
    r: 1.972,
    fill: "#f2f2f2",
    className: "cls-5",
    "data-name": "Ellipse 6",
    transform: "translate(1.669 9.556)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSColor);
export default __webpack_public_path__ + "static/media/sColor.e3a59d23aeff25f724337d526aaf119d.svg";
export { ForwardRef as ReactComponent };